import { apiGateway } from "@/_old/services/api-gateway";

export const getInsightsApi = async (
  path: string,
  startDate?: string,
  endDate?: string,
  limit?: number,
  companyId?: string,
) => {
  const queryParams = new URLSearchParams();

  if (startDate) {
    queryParams.set("start_date", startDate);
  }
  if (endDate) {
    queryParams.set("end_date", endDate);
  }
  if (limit) {
    queryParams.set("limit", limit.toString());
  }
  if (companyId) {
    queryParams.set("company_id", companyId);
  }

  const apiUrl = `${path}?${queryParams.toString()}`;

  const { data } = await apiGateway.get(apiUrl);

  return data;
};
